import { render, staticRenderFns } from "./QuestionMetric.vue?vue&type=template&id=4c70bb01&scoped=true&"
import script from "./QuestionMetric.vue?vue&type=script&lang=js&"
export * from "./QuestionMetric.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMetric.vue?vue&type=style&index=0&id=4c70bb01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70bb01",
  null
  
)

export default component.exports